import type { EvaluationTypeValue } from '@/constants/cycle-evaluation/CycleEvaluation';
import type { CycleEvaluation } from '@/types/cycle-evaluation/CycleEvaluation';

import { api } from '@/api/api';

export default {
    async getCycleEvaluation(id: string): Promise<CycleEvaluation> {
        const response = await api.get(`/cycleevaluation/${id}`);

        return response.data;
    },

    async getCycleEvaluationList(): Promise<CycleEvaluation[]> {
        const response = await api.get('/cycleevaluation');

        return response.data;
    },

    async createCycleEvaluation(
        reviewType: EvaluationTypeValue,
        cycleEvaluationGroupId?: string,
    ): Promise<CycleEvaluation> {
        const response = await api.post('/cycleevaluation', { reviewType, cycleEvaluationGroupId });

        return response.data;
    },

    async updateCycleEvaluation(cycleEvaluation: CycleEvaluation): Promise<CycleEvaluation> {
        const response = await api.put(`/cycleevaluation/${cycleEvaluation.id}`, cycleEvaluation);

        return response.data;
    },

    async deleteCycleEvaluation(id: string): Promise<void> {
        const response = await api.delete(`/cycleevaluation/${id}`);

        return response.data;
    },

    async launchCycleEvaluation(id: string): Promise<void> {
        const response = await api.post(`/cycleevaluation/${id}/launch`);

        return response.data;
    },
};
